import React from "react";
import { Box, Flex, Button, Image } from "@chakra-ui/react";
import { PlusIcon } from "./Icons";

export function AddSalesExecutive() {
  return (
    <Box 
      as="article" 
      display="flex"
      justifyContent="center"
      alignItems="center"
      bg="white"
      borderRadius="xl"
      border="1px dashed"
      borderColor="black"
      height="268px"
      transition="all 0.3s ease"
      _hover={{
        transform: "scale(1.02)", 
        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.15)",
        borderColor: "#805ad6",
        borderStyle: "dashed"
      }}
    >
      <Flex flexDirection="column" gap={5} alignItems="center">
        <Image
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/945ea33dd069b449fdbf33b9b03f164dc418f0f6"
          alt="Sales Executive Icon"
          height="177px"
          width="177px"
        />
        {/* <Button
          leftIcon={<PlusIcon />}
          size="xs"
          px={4}
          py={2}
          color="white"
          bg="gray.800"
          borderRadius="md"
          _hover={{ bg: "gray.700" }}
        >
          Sales Executive
        </Button> */}
      </Flex>
    </Box>
  );
} 